<script>
import e4parent from "./e4parent";
export default {
  extends: e4parent,
  props: {},
  methods: {
    /* setOption() {
      this.isEmpty = true;
      this.$nextTick(() => {
        this.render(this.getMockData());
      });
    }, */
    getFormatExParams() {
      return {};
    },
    getMockData() {
      let res = {
        data: [
          {
            value: "100",
            name: "未入章",
          },
          {
            value: ["11", "2002"],
            name: "已入章1",
          },
          {
            value: "200",
            name: "已入章2",
          },
          {
            value: "10",
            name: "已入章3",
          },
          {
            value: [200],
            name: "已入章4",
          },
        ],
      };
      return res;
    },
    getLegendData: function (data) {
      let legendData = [];
      let len = data.length;
      for (let i = 0; i < len; i++) {
        let item = data[i];
        let name = item.name;
        legendData.push(name);
      }
      return legendData;
    },
    packageData: function (res) {
      let title = this.title;
      let colorData = this.colorData;
      let seriesData = res.data;
      let legendData = this.getLegendData(seriesData);
      return {
        title: title,
        legendData: legendData,
        seriesData: seriesData,
        colorData: colorData,
      };
    },
    getEchartsOptions(res) {
      res = res.data;
      let data = this.packageData(res);
      let title = data.title;
      let colorData = data.colorData;
      let seriesData = data.seriesData;
      let legendData = data.legendData;
      let option = {
        title: {
          text: title,
          x: "center",
          textStyle: {
            color: "#fff",
            fontSize: 14,
            fontWeight: "normal",
          },
        },
        color: colorData,
        tooltip: {
          confine: true,
          trigger: "item",
          formatter: "{b}({c})",
        },
        legend: {
          orient: "vertical",
          right: 30,
          y: "middle",
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          type: "scroll",
          height: 150,
          formatter: function (name) {
            let info = "";
            let infoLen = name.length;
            let limit = 6;
            let strLen = Math.ceil(infoLen / limit);
            if (infoLen > limit) {
              for (let j = 0; j < strLen; j++) {
                j && (info = info + "\n");
                info = info + name.substr(j * limit, limit);
                if (!j) {
                  info = info + " " + getInfoValue(name);
                }
              }
            } else {
              info = name;
              for (let i = 0; i < limit - infoLen; i++) {
                info = info + " ";
              }
              info = info + " " + getInfoValue(name);
            }
            function getInfoValue(name) {
              let value = "";
              let len = seriesData.length;
              for (let i = 0; i < len; i++) {
                let item = seriesData[i];
                if (name == item.name) {
                  value = item.value;
                  value = value ? value + "%" : "";
                  break;
                }
              }
              return "";
            }
            return "{name|" + info + "}";
          },
          textStyle: {
            color: this.chartsLabelColor,
            rich: {
              name: {
                lineHeight: 18,
              },
            },
          },
          data: legendData,
        },
        series: [
          {
            type: "pie",
            selectedMode: "single",
            center: ["30%", "50%"],
            radius: ["30%", "50%"],
            label: {
              // rotate: true,
              overflow: "none",
              show: true,
              position: "outside",
              margin: 0,
              formatter: "{per|{d}%}",
              color: this.chartsLabelColor,
              rich: {
                B: {
                  fontSize: 12,
                  color: "#fff",
                  width: 50,
                  height: 24,
                },
              },
            },
            labelLine: {
              show: false,
              showAbove: false,
              length: 0,
              length2: 0,
            },
            labelLayout: {
              hideOverlap: false,
              moveOverlap: true,
              // rotate: true,
            },
            data: seriesData,
          },
        ],
      };
      return option;
    },
  },
};
</script>
